// Brand-level constants. Must mirror values in /app/backend/server.py.
export const GOOGLE_REVIEW_URL = "https://g.page/r/CRTshmJCLAH4EBM/review";
export const BUSINESS_NAME = "Fuego Precision Detailing";
export const JOBBER_BOOKING_URL = "https://clienthub.getjobber.com/hubs/1d9a41d5-94c5-4016-922a-edae94a1b66c/public/requests/5039071/new";
